import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  createJob,
  editInActive,
  editJob,
  filterByJobTypeInActive,
} from "../../features/jobsFinder/jobsFinderSlice";
const initialState = {
  title: "",
  type: "",
  deadline: "",
  salary: "",
};

export default function AddEditJobsFinder() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { editing } = useSelector((state) => state.jobs) || {};
  const [values, setValues] = useState(initialState);
  const [editMode, setEditMode] = useState();

  useEffect(() => {
    const { id, title, type, deadline, salary } = editing || {};
    if (id) {
      setEditMode(true);
      setValues({
        title,
        type,
        deadline,
        salary,
      });
    } else {
      setEditMode(false);
      reset();
    }
  }, [editing]);

  // HANDLER START
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };
  const submitHandlerAdd = (e) => {
    e.preventDefault();
    dispatch(createJob(values));

    dispatch(filterByJobTypeInActive());
    reset();
    navigate("/");
  };
  const submitHandleEdit = (e) => {
    e.preventDefault();
    dispatch(
      editJob({
        id: editing?.id,
        data: { ...values },
      })
    );
    setEditMode(false);
    reset();
    dispatch(editInActive());
    dispatch(filterByJobTypeInActive());
    navigate("/");
  };
  // HANDLER END
  //HELPER FUNCTION START
  function reset() {
    setValues({
      title: "",
      type: "",
      deadline: "",
      salary: "",
    });
  }
  //HELPER FUNCTION END
  return (
    <div className="lg:pl-[14rem] mt-[5.8125rem]">
      <main className="max-w-3xl rounded-lg mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
        <h1 className="mb-10 text-center lws-section-title">
          {editMode ? "Edit Job" : "Add New Job"}
        </h1>

        <div className="max-w-3xl mx-auto">
          <form
            onSubmit={editMode ? submitHandleEdit : submitHandlerAdd}
            className="space-y-6"
          >
            <div className="fieldContainer">
              <label
                htmlFor="lws-JobTitle"
                className="text-sm font-medium text-slate-300"
              >
                Job Title
              </label>
              <select
                id="lws-JobTitle"
                name="title"
                value={values.title}
                onChange={changeHandler}
                required
              >
                <option value="" hidden>
                  Select Job
                </option>
                <option value="Software Engineer">Software Engineer</option>
                <option value="Software Developer">Software Developer</option>
                <option value="Full Stack Developer">
                  Full Stack Developer
                </option>
                <option value="MERN Stack Developer">
                  MERN Stack Developer
                </option>
                <option value="DevOps Engineer">DevOps Engineer</option>
                <option value="QA Engineer">QA Engineer</option>
                <option value="Product Manager">Product Manager</option>
                <option value="Social Media Manager">
                  Social Media Manager
                </option>
                <option value="Senior Executive">Senior Executive</option>
                <option value="Junior Executive">Junior Executive</option>
                <option value="Android App Developer">
                  Android App Developer
                </option>
                <option value="IOS App Developer">IOS App Developer</option>
                <option value="Frontend Developer">Frontend Developer</option>
                <option value="Frontend Engineer">Frontend Engineer</option>
              </select>
            </div>

            <div className="fieldContainer">
              <label htmlFor="lws-JobType">Job Type</label>
              <select
                id="lws-JobType"
                name="type"
                value={values.type}
                onChange={changeHandler}
                required
              >
                <option value="" hidden>
                  Select Job Type
                </option>
                <option value="Full Time">Full Time</option>
                <option value="Internship">Internship</option>
                <option value="Remote">Remote</option>
              </select>
            </div>

            <div className="fieldContainer">
              <label htmlFor="lws-JobSalary">Salary</label>
              <div className="flex border rounded-md shadow-sm border-slate-600">
                <span className="input-tag">BDT</span>
                <input
                  type="number"
                  name="salary"
                  value={values.salary}
                  onChange={changeHandler}
                  id="lws-JobSalary"
                  required
                  className="!rounded-l-none !border-0"
                  placeholder="20,00,000"
                />
              </div>
            </div>

            <div className="fieldContainer">
              <label htmlFor="lws-JobDeadline">Deadline</label>
              <input
                type="date"
                name="deadline"
                value={values.deadline}
                onChange={changeHandler}
                id="lws-JobDeadline"
                required
              />
            </div>

            <div className="text-right">
              <button
                type="submit"
                id="lws-submit"
                className="cursor-pointer btn btn-primary w-fit"
              >
                {editMode ? "Update" : "Add"}
              </button>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
}
